import * as url from "../../helpers/url_helper";
import { apiCall, fetchApi, processDeleteResponse } from "./apiService";

/**
 * Loads logs with error handling
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Array|null>} Array of logs or null if error
 */
export const loadLogsData = async (notifyError) => {
    return await apiCall(
        url.GET_ERROR_LOGS,
        'GET',
        null,
        notifyError,
        "Failed to load logs"
    );
};

/**
 * Clears logs with error handling
 * @param {Function} notifySuccess - Success notification function
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<boolean>} True if successful, false otherwise
 */
export const clearLogsData = async (notifySuccess, notifyError) => {
    try {
        const { response, results } = await fetchApi(url.DELETE_ERROR_LOGS, 'DELETE');
        return processDeleteResponse(
            response,
            results,
            notifySuccess,
            notifyError,
            "Logs cleared successfully",
            "Error clearing logs"
        );
    } catch (err) {
        notifyError("Error clearing logs. Please check your network connection.");
        return false;
    }
};

